// extracted by mini-css-extract-plugin
module.exports = {"loader_container":"loader_loader_container__veb2p","lds_spinner":"loader_lds_spinner__2qHKl","lds-spinner":"loader_lds-spinner__pv5X7"};